import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Box, Paper, Typography } from '@mui/material';

export interface BoardDropzoneOverlayProps {
  isActive: boolean;
  isUploading: boolean;
  uploadCount: number;
}

const BoardDropzoneOverlay = ({ isActive, isUploading, uploadCount }: BoardDropzoneOverlayProps) => {
  if (!isActive && !isUploading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(25, 118, 210, 0.12)',
        border: '3px dashed',
        borderColor: 'primary.main',
        pointerEvents: 'none',
      }}
    >
      <Paper sx={{ p: 3, minWidth: 300, textAlign: 'center', borderRadius: 2 }}>
        <CloudUploadOutlinedIcon color="primary" sx={{ fontSize: 42, mb: 0.5 }} />
        <Typography variant="h6" sx={{ mb: 0.5 }}>
          {isUploading ? 'Uploading files...' : 'Drop images or files to add cards'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {isUploading
            ? `${uploadCount} ${uploadCount === 1 ? 'card' : 'cards'} being added`
            : 'Release to upload'}
        </Typography>
      </Paper>
    </Box>
  );
};

export default BoardDropzoneOverlay;
